import { ExportInterfaceConfigurationFileProcessType } from './../../../../../../base/models/models.swagger.generated';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  ExportInterfaceConfigurationFileFormat,
  ExportInterfaceConfigurationDecimalSeparator,
  ExportInterfaceConfigurationDetailsFileDTO,
  ExportInterfaceConfigurationSeparator,
  ExportInterfaceConfigurationTextFormat,
  ExportInterfaceCurrency,
} from 'src/app/base/models/models.swagger.generated';
import { ConfigurationFormCoordinatorService } from '../../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationFormFileNamePlaceholderComponent } from './configuration-form-file-name-placeholder/configuration-form-file-name-placeholder.component';
import { AlphanumericDirective } from '../../../../../../directives/alphanumeric.directive';
import { YesNoGroupButtonComponent } from '../../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { EnumDropDownListComponent } from '../../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';

@Component({
    selector: 'app-configuration-form-file-name',
    templateUrl: './configuration-form-file-name.component.html',
    styleUrls: ['./configuration-form-file-name.component.scss'],
    imports: [
        ReactiveFormsModule,
        EnumDropDownListComponent,
        NumericTextBoxModule,
        AppErrorMessagesComponent,
        YesNoGroupButtonComponent,
        AlphanumericDirective,
        ConfigurationFormFileNamePlaceholderComponent,
        TranslateModule,
        AlphanumericDirective
    ]
})
export class ConfigurationFormFileNameComponent {

  @Input() public data: ExportInterfaceConfigurationDetailsFileDTO;

  public FileFormat = ExportInterfaceConfigurationFileFormat;
  public DecimalSeparator = ExportInterfaceConfigurationDecimalSeparator;
  public Currency = ExportInterfaceCurrency;
  public Separator = ExportInterfaceConfigurationSeparator;
  public TextFormat = ExportInterfaceConfigurationTextFormat;
  public ProcessType = ExportInterfaceConfigurationFileProcessType;

  public get configurationFormFileName(): UntypedFormGroup {
    return this.configurationFormService.configurationFormFileName;
  }

  constructor(
    private configurationFormService: ConfigurationFormCoordinatorService) {
  }
}
